import React, { type ReactNode } from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./field-helper-text.module.scss";

const cx = c.bind(styles);

export type FieldHelperTextProps = Omit<BaseProps, "children" | "id"> & {
  children: ReactNode;
  disabled?: boolean;
  id: string;
  negative?: boolean;
};

const rootClassName = "purpur-field-helper-text";

export const FieldHelperText = ({
  children,
  className,
  disabled,
  id,
  negative,
  ...props
}: FieldHelperTextProps) => {
  const classes = cx(className, rootClassName, {
    [`${rootClassName}--disabled`]: disabled,
    [`${rootClassName}--negative`]: negative,
  });

  return (
    <span id={id} className={classes} {...props}>
      {children}
    </span>
  );
};
